import React from "react";
import "./index.css";
import "./App.css";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import LomiLomiNui from "./pages/LomiLomiNui";
import SechsTibeter from "./pages/SechsTibeter";
import UeberMich from "./pages/UeberMich";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

// Use HashRouter in production builds (works on any static host, no .htaccess needed)
// BrowserRouter in dev for preview.
const isProdBuild = process.env.NODE_ENV === "production";
const Router = isProdBuild ? HashRouter : BrowserRouter;

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App relative min-h-screen">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/lomi-lomi-nui" element={<LomiLomiNui />} />
            <Route path="/6-tibeter" element={<SechsTibeter />} />
            <Route path="/ueber-mich" element={<UeberMich />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
